import axios from "axios";
import BaseFilter from "../filters/BaseFilter";
import Accordion from "./Accordion";
import LazyLoadController from "./LazyLoadController";

export default class Search extends BaseFilter {
    init() {
        this.DOM = {
            searchWrapper: ".js-search-results",
            searchInput: ".js-search-input",
            resultsWrapper: ".js-search-results-wrapper",
            loader: ".js-search-loader",
            deleteSearch: ".js-delete-search",
            goBack: ".js-go-back",
            states: {
                active: "is-active"
            }
        }

        this.searchInput = document.querySelector(this.DOM.searchInput);

        if (this.searchInput !== null) {
            this.initVariables();
            this.initSearch();
            this.initDeleteSearch();
            this.initBack();
        }

    }

    initBack() {
        let last_url = sessionStorage.getItem('last_url');

        if (typeof last_url !== 'undefined' && last_url !== '') {
            this.goBack.href = last_url;
        }
    }


    initDeleteSearch() {
        this.deleteSearch.addEventListener('click', (event) => {
            this.searchInput.value = '';
            this.searchInput.dispatchEvent(new Event('keyup'));
        });
    }

    initSearch() {
        this.searchInput.addEventListener('keyup', (event) => {
            this.liveSearchLogic(event);
        });

        if (this.searchInput.value !== '') {
            this.searchInput.dispatchEvent(new Event('keyup'));
        }
    }

    initVariables() {
        this.searchWrapper = document.querySelector(this.DOM.searchWrapper);
        this.resultsWrapper = document.querySelector(this.DOM.resultsWrapper);
        this.loader = document.querySelector(this.DOM.loader);
        this.deleteSearch = document.querySelector(this.DOM.deleteSearch);
        this.goBack = document.querySelector(this.DOM.goBack);
        this.timer = 0;
    }

    liveSearchLogic(event) {
        let self = event.currentTarget;
        let code = event.keyCode || event.which;
        if (code === 13 || self.value === '') {
            this.search();

            return;
        }


        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            this.search();
        }, 500);
    }

    getParams() {
        let params = '?search=' + this.searchInput.value;
        let currentLanguage = this.getBodyElement().getAttribute("data-current-language");

        if (this.searchWrapper) {
            params += '&archive-url=' + encodeURIComponent(this.searchWrapper.getAttribute('data-archive-url'));
        }

        if (currentLanguage) {
            params += "&current-language=" + currentLanguage;
        }

        return params;
    }

    search() {
        if (this.searchInput.value === '') {
            this.searchWrapper.innerHTML = '';
            this.setState(this.searchWrapper.getAttribute('data-archive-url'), true)
            return;
        }
        let url = this.getApiUrlFromElement(this.DOM.searchWrapper);
        let params = this.getParams();
        this.loader.classList.add(this.DOM.states.active);

        axios.get(this.getGlobalApiUrl() + '/' + url + params).then((response) => {
            this.afterAjaxCall(response.data, true);
        });
    }

    afterAjaxCall(data, stateHistory) {
        if (data.html) {
            this.searchWrapper.innerHTML = data.html;
            new Accordion();
            new LazyLoadController();
        }

        this.loader.classList.remove(this.DOM.states.active);
        this.setState(data.url, stateHistory);

    }

    setState(url, stateHistory) {
        if (url && stateHistory) {
            let stateData = {
                url: url,
                random: Math.random(),
                source: "swup",
            };

            this.updateUrls(stateData, url);
        }
    }


}
